import { z } from 'my-zod'
import { vehicleUseHistoryModel } from './vehicle-use-history-model'

export const vehiclePrepCreateView = vehicleUseHistoryModel.pick({
  id: true,
  operatorId: true,
  createdDate: true,
  lastModifiedDate: true,
  vin: true,
  vehicleId: true,
  operatorUnitNumber: true,
  checkOutEngineHours: true,
  checkOutMileage: true,
  checkOutTreadDepth32ndInches: true,
  checkOutConditionNotes: true,
  checkOutFuelLevel: true,
  checkOutVehicleImages: true
})
export type vehiclePrepCreateView = z.infer<typeof vehiclePrepCreateView>
